export const gitCommit = '0386dbcd'
